import { Box, Button, IconButton, Input, NumberInput, NumberInputField, Select, Stack, Text, Tooltip } from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { OrderCategoryItem } from "models/order_category_item";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";
import { OptionType } from "models/select_mode";
import { useEffect, useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import { MdEdit } from "react-icons/md";
import formatNumber from "../hooks/formatNumber";

interface IOrderItemRow {
    item1 :OrderCategoryItem;
    index1 : number;
    index: number;
    editItem : (data: OrderCategoryItem, tipo: string, value: string) => void;
    deleteRow1: (value: OrderCategoryItem) => void;
    produtos : ProductType[];
    unidades : ClientClassificationType[];
    edit: (item: ProductType) => void;
}



const OrderItemRow = ({item1, index1, index, produtos, editItem, unidades, deleteRow1, edit}: IOrderItemRow) => {

    const [produtoTexto, setProdutoTexto] = useState("");
    const [selectedProduto, setSelectedProduto] = useState<ProductType>(null);
    const [produto, setProduto] = useState("");
    const [descricao, setDescricao] = useState("");
    const [unidade, setUnidade] = useState("");
    const [unidadeTexto, setUnidadeTexto] = useState("");
    const [quantidade, setQuantidade] = useState("1");
    const [valor, setValor] = useState("");
    const [total, setTotal] = useState(0);
    const [selectedProdutoItens, setSelectedProdutoItens] =
    useState<ProdutoItemType>();

    const [unidadesDisponiveis, setUnidadesDisponiveis] = useState<
    ClientClassificationType[]
  >([]);
  const [unidadePadrao, setUnidadePadrao] =
    useState<ClientClassificationType>();


    const changeProduto = (item: string) => {
        const prdUn = produtos?.find((value) => value.id === item);
        setSelectedProduto(prdUn);
        const unDisp: ClientClassificationType[] = [];
        unidades?.forEach((v) => {
          const existe = prdUn?.ProdutoUnidade?.find(
            (un) => un.unidadeMedidaId === v.id
          );
          if (existe) {
            unDisp.push(v);
            if (existe.principal) {
              changeUnidade(existe.unidadeMedidaId);
              const selected = prdUn.ProdutoUnidade.find(
                (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
              );
              if (selected) {
                setSelectedProdutoItens(selected);
                const media =
                  (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
                setValor(Number(media).toFixed(2));
              }
              setUnidadePadrao({
                id: existe.unidadeMedidaId,
                idEmpresa: prdUn.idEmpresa,
                nome: v.nome,
              });
            }
          }
        });
    
        setUnidadesDisponiveis(unDisp);
        setProdutoTexto(prdUn.nome);
        setProduto(item);
        editItem(item1, "produto", item);
      };
    
      const changeDescricao = (item: string) => {
        setDescricao(item);
      };
    
      const changeUnidade = (item: string) => {
        const un = unidades?.find((val) => val.id === item);
        const prdUn = produtos?.find((value) => value.id === produto);
        const selected = prdUn?.ProdutoUnidade.find(
          (prd) => prd?.unidadeMedidaId === item
        );
        if (selected) {
          editItem(item1, "unidade", item)
          setSelectedProdutoItens(selected);
          const media = (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
          setValor(Number(media).toFixed(2));
          setUnidade(item);
          setUnidadeTexto(un.nome);
          const valorTotal =  media * Number(quantidade);
          setTotal(valorTotal);

        }

      };
      const changeQuantidade = (item: string) => {
        setQuantidade(item);
      };
    
      const changeValor = (item: string) => {
        setValor(item);
      };

      const calculate = (item: string) => {
        editItem(item1, "valor", item);  

        let totalUn =  Number(valor);
        const min = Number(selectedProdutoItens?.valorMin);
        const max = Number(selectedProdutoItens?.valorMax);

        if( totalUn < min) {
            totalUn = min;
        }
        if( totalUn > max) {
            totalUn = max;
        }
        let total = totalUn * Number(quantidade);

        setTotal(total);              
        changeValor(totalUn.toString());
      }
      

    useEffect(() => {
        if(item1) {
            setProdutoTexto(item1.produtoNome);
            setProduto(item1.produtoId);
            setDescricao(item1.descricao);
            setUnidade(item1.unidadeMedidaId);
            setUnidadeTexto(item1.unidadeNome);
            setQuantidade(Number(item1.quantidade).toFixed(2));
            setValor(Number(item1.valorUn).toFixed(2));
            setTotal(item1.valorTotal);
            const prdUn = produtos?.find((value) => value.id === item1.produtoId);
            setSelectedProduto(prdUn);
            const unDisp: ClientClassificationType[] = [];
            unidades?.forEach((v) => {
              const existe = prdUn?.ProdutoUnidade.find(
                (un) => un.unidadeMedidaId === v.id
              );
              if (existe) {
                unDisp.push(v);
                if (existe.principal) {
                  const selected = prdUn?.ProdutoUnidade.find(
                    (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
                  );
                  if (selected) {
                    setSelectedProdutoItens(selected);
                  }
                }
              }
            });
            
            setUnidadesDisponiveis(unDisp);

        }
    }, [item1, produtos, unidades]);

    return(
        <Draggable
        key={`${item1.descricao}-${item1.produtoNome}-${item1.unidadeMedidaId}`}
        draggableId={`${item1.id}-${item1.produtoId}--${index1}`}
        index={index1}
      >
        {(provided1, snapshot1) => (
          <Stack
            key={`${item1.id}-${item1}-${index1}-${provided1.innerRef}`}
            ref={provided1.innerRef}
            {...provided1.draggableProps}
            {...provided1.dragHandleProps}
            flex="1"
            padding={6}
            flexDirection={"row"}
            justifyContent={"space-between"}
          >
            <Text
              textAlign="left"
              color={"black"}
              fontWeight={"bold"}
              fontSize={14}
              alignSelf={"center"}
            >
              {index + 1}. {index1 + 1}
            </Text>

            <Box width={370} alignSelf={"flex-start "}>
                <Box w={"86%"}>
                  <AutoComplete<
                    OptionType,
                    false,
                    GroupBase<OptionType>
                  >
                    size="md"
                    onChange={(e) =>
                        changeProduto(e.value)           
                    }
                    placeholder="Buscar..."
                    name={"Produto"}
                    options={produtos?.map((item) => {
                      return {
                        label: item?.nome,
                        value: item?.id,
                      };
                    })}
                    value={{
                      label: produtoTexto,
                      value: produto,
                    }}
                  />
                  </Box>
                  <IconButton
                    colorScheme="brand"
                    variant="solid"
                    mt={-10}
                    ml={8}
                    borderRadius={8}
                    icon={<MdEdit />}
                    onClick={() => {
                      edit(selectedProduto)
                    }}
                    float={"right"}
                    aria-label={"Adicionar Itme"}
                  />
            </Box>

            <Box width={250} alignSelf={"flex-start"}>
              <Input
                isRequired={false}
                fontSize="sm"
                value={descricao}
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Digite a Descrição"
                fontWeight="500"
                name={`descricao--${index1}-${descricao}`}
                border={"none"}
                size="md"
                onChange={(e) => changeDescricao(e.target.value)}
                onBlur={(e) =>
                  editItem(item1, "descricao", e.target.value)
                }
              />
            </Box>
            <Box width={200}>
              <Select
                size="md"
                onChange={(e) => changeUnidade(e.target.value)}
                defaultValue={unidade}
                name={`unidade-${index1}-${index}`}
              >
                {unidadesDisponiveis.map((item) => (
                  <option value={item?.id}>
                    {
                      item?.nome
                    }
                  </option>
                ))}
              </Select>
            </Box>

            <Box width={100}>
              <NumberInput
                precision={2}
                step={1}
                min={1}
                name={`quantidade--${index1}-${quantidade}`}
                value={quantidade}
                onChange={(e) => changeQuantidade(e)}
                onBlur={(e) =>
                  editItem(item1, "quantidade", e.target.value)
                }
              >
                <NumberInputField />
              </NumberInput>
            </Box>

            <Box width={128}>
            <Tooltip
            label={`O valor deve ser entre ${formatNumber(
              isNaN(Number(selectedProdutoItens?.valorMin)) ? 0 : formatNumber(Number(selectedProdutoItens?.valorMin))
            )} e ${formatNumber(
              isNaN(Number(selectedProdutoItens?.valorMax)) ? 0 : formatNumber(Number(selectedProdutoItens?.valorMax))
            )}`} >
          
            <NumberInput
                precision={2}
                name={`valor--${index1}-${valor}`}
                value={valor}
                onChange={(e) => changeValor(e)}
                onBlur={(e) =>
                    calculate(e.target.value)              
                }
              >
                <NumberInputField />  
              </NumberInput>
            </Tooltip>
            </Box>

            <Text
              textAlign="left"
              color={"black"}
              fontSize={14}
              alignSelf={"center"}
              width={150}
            >
             {formatNumber(Number(total))}
            </Text>

            <Button
              onClick={() => deleteRow1(item1)}
              colorScheme="red"
              variant="ghost"
              ml="1"
            >
              Excluir
            </Button>
          </Stack>
        )}
      </Draggable>
    )
}
export default OrderItemRow;